import axios from 'axios'
import { useCallback, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { handleError, removeEmptyObjectValues } from 'src/utils/helpers'

const useFetch = (showToast, t, transformer = null) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [data, setData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const cancelTokenRef = useRef(null)

  const fetchData = useCallback(
    async (searchParams, serviceMethod, ...transformerArgs) => {
      if (location?.state?.message) {
        showToast({
          color: location?.state?.color ?? 'success',
          message: t(location?.state?.message),
          visible: true,
        })
        navigate(
          { ...location, state: { ...location.state, message: undefined } },
          { replace: true },
        )
      }
      if (cancelTokenRef.current) {
        cancelTokenRef.current.cancel()
      }
      cancelTokenRef.current = axios.CancelToken.source()
      try {
        setIsLoading(true)
        const res = await serviceMethod(
          removeEmptyObjectValues(searchParams),
          cancelTokenRef.current,
        )
        if (!res.data.success) throw res
        setData(transformer ? transformer(res.data.data, ...transformerArgs) : res.data.data)
      } catch (error) {
        if (!axios.isCancel(error)) {
          showToast({
            color: 'danger',
            message: handleError(error?.response?.data),
            visible: true,
          })
        }
      } finally {
        setIsLoading(false)
      }
    },
    [location, navigate, t, transformer],
  )

  return [data, fetchData, isLoading]
}

export default useFetch
